export default function getProjectShareUrl(config, project) {
  return `${config.custom.platformUrl()}/share/project/${project.id}`;
}
